import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {loadWebUsers} from '../../actions/users';
import UsersControlPanel from './UsersControlPanel';
import UsersTable from './UsersTable';

export const Users = () => {
  const dispatch = useDispatch();

  // The socket is already open here — Head connects once for the whole panel.
  useEffect(() => {
    dispatch(loadWebUsers(null) as any);
  }, [dispatch]);

  return (
    <div style={{overflow: 'hidden', width: '100%'}}>
      <div className={'users-container'}>
        <UsersControlPanel/>
        <UsersTable/>
      </div>
    </div>
  );
};
